import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-100 py-8" }
const _hoisted_2 = { class: "max-w-md mx-auto bg-white rounded-lg shadow-lg p-6" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-600 mb-4"
}
const _hoisted_4 = {
  key: 1,
  class: "text-green-600 mb-4"
}
const _hoisted_5 = { class: "text-xl font-semibold text-gray-700" }
const _hoisted_6 = { class: "text-gray-600" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-2xl font-bold text-gray-800 mb-6 text-center" }, "Preview Your Answers", -1)),
      (_ctx.unansweredQuestions.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("p", null, "Please answer all questions before submitting:", -1)),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unansweredQuestions, (question) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: question.id
                }, _toDisplayString(question.text), 1))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[2] || (_cache[2] = [
            _createElementVNode("p", null, "All questions answered! You can submit your responses.", -1)
          ]))),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question) => {
        return (_openBlock(), _createElementBlock("div", {
          key: question.id,
          class: "mb-4"
        }, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(question.text), 1),
          _createElementVNode("p", _hoisted_6, "Your answer: " + _toDisplayString(_ctx.answers[question.id] || 'No answer provided'), 1),
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.goToQuestion(question.id)),
            class: "text-blue-500 underline"
          }, "Edit", 8, _hoisted_7)
        ]))
      }), 128)),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
        class: "mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg"
      }, " Submit ")
    ])
  ]))
}